/**
* Formulaire de login notaire (destiné LIDIA)
*/
export class LoginBean {
    login: string;
    password: string;

    constructor() {
        this.login = "";
        this.password = "";
     }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/login-bean.model.ts